import { initializeApp } from '@firebase/app'
import { getStorage } from '@firebase/storage'

if (!process.env.NEXT_PUBLIC_PROJECT_ID) {
  throw new Error('NEXT_PUBLIC_PROJECT_ID is not set')
}

if (!process.env.NEXT_PUBLIC_STORAGE_BUCKET) {
  throw new Error('NEXT_PUBLIC_STORAGE_BUCKET is not set')
}

if (!process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID) {
  throw new Error('NEXT_PUBLIC_MESSAGING_SENDER_ID is not set')
}

if (!process.env.NEXT_PUBLIC_APP_ID) {
  throw new Error('NEXT_PUBLIC_APP_ID is not set')
}

if (!process.env.NEXT_PUBLIC_EXTERNAL_URL) {
  throw new Error('NEXT_PUBLIC_EXTERNAL_URL is not set')
}

if (!process.env.NEXT_PUBLIC_MIX_PANEL_ID) {
  throw new Error('NEXT_PUBLIC_MIX_PANEL_ID is not set')
}

const config = {
  apiKey: process.env.NEXT_PUBLIC_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_APP_ID
}
const firebase = initializeApp(config)
export const storage = getStorage(firebase)

export const externalUrl = process.env.NEXT_PUBLIC_EXTERNAL_URL
